<template>
  <svg v-if="vehicleType=='bus'" xmlns="http://www.w3.org/2000/svg" viewBox="-10 -10 54 56" role="img" class="marker-bus">
    <circle-with-arrow :colorBearing="colorBearing" :transformBearing="transformBearing" :colorBackground="colorBus">
    </circle-with-arrow>
    <bus-markup :colorBackground="colorBackground"></bus-markup>
  </svg>

  <svg v-else-if="vehicleType=='tramway'" xmlns="http://www.w3.org/2000/svg" viewBox="-10 -10 54 56" role="img" class="marker-tram">
    <circle-with-arrow :colorBearing="colorBearing" :transformBearing="transformBearing" :colorBackground="colorBackground">
    </circle-with-arrow>
    <circle :fill="colorBus" cx="23.49" cy="22.82" r="1.12"/>
    <circle :fill="colorBus" cx="10.51" cy="22.82" r="1.12"/>
    <g transform="scale(0.1) translate(30, 10)">
      <path :fill="colorBus" d="m 251.14,235.84 c 2.19,0 3.97,-1.78 3.97,-3.97 v -3.97 c 0,-2.19 -1.78,-3.96 -3.97,-3.96 H 28.35 v 11.91 H 251.14 M 28.35,170.78 H 69.6 c 1.09,0 1.98,-0.89 1.98,-1.98 v -54.85 c 0,-1.09 -0.89,-1.98 -1.98,-1.98 H 28.35 V 99.21 H 92.72 L 117.95,78.47 86.21,52.39 c -1.37,-1.12 -1.57,-3.15 -0.44,-4.52 l 2.04,-2.49 c 1.13,-1.37 3.15,-1.56 4.52,-0.44 l 36.14,29.69 c 2.41,1.98 2.42,5.68 0,7.66 L 107.89,99.2 h 98.03 c 7.78,0 15.18,3.29 20.43,9.03 15.45,16.89 25.27,37.77 28.41,60.39 1,7.19 -0.09,14.31 -3.16,20.56 -7.09,14.44 -21.47,23.41 -37.55,23.41 H 28.35 Z m 188.48,-54.06 c -2.8,-3.05 -6.77,-4.75 -10.91,-4.75 h -34.57 c -1.09,0 -1.98,0.89 -1.98,1.98 v 54.85 c 0,1.09 0.89,1.98 1.98,1.98 h 59.11 c 6.94,0 11.07,-5.46 9.31,-12.17 -4.1,-15.56 -11.91,-29.87 -22.94,-41.89 m -62.2,83.12 c 1.09,0 1.98,-0.89 1.98,-1.98 v -83.91 c 0,-1.09 -0.89,-1.98 -1.98,-1.98 h -25.79 c -1.1,0 -1.99,0.89 -1.99,1.98 v 83.91 c 0,1.09 0.89,1.98 1.99,1.98 h 25.79 M 86.32,111.97 c -1.09,0 -1.98,0.89 -1.98,1.98 v 83.91 c 0,1.09 0.89,1.98 1.98,1.98 h 25.79 c 1.1,0 1.99,-0.89 1.99,-1.98 v -83.91 c 0,-1.09 -0.89,-1.98 -1.99,-1.98 H 86.32" />
    </g>
  </svg>

  <svg  v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34" role="img" class="marker-bus">
    <circle-with-arrow :colorBearing="colorBearing" :transformBearing="transformBearing" :colorBackground="colorBus">
    </circle-with-arrow>
    <bus-markup :colorBackground="colorBackground"></bus-markup>
  </svg>

</template>

<script>
export default {
  name: 'mapMarkerTransportSVG',
  components: {
    CircleWithArrow : {
      props: ['colorBearing', 'transformBearing', 'colorBackground'],
      template: `<g :transform="transformBearing">
        <polygon points="17,-10 2,10 32,10" :fill="colorBearing" />
        <circle :fill="colorBackground" cx="17" cy="17" r="16.5"></circle>
        </g>`,
    },
    BusMarkup: {
      props: ['colorBackground'],
      template: `<g><circle :fill="colorBackground" cx="23.49" cy="22.82" r="1.12"/>
        <circle :fill="colorBackground" cx="10.51" cy="22.82" r="1.12"/>
        <rect :fill="colorBackground" x="12.53" y="7.61" width="8.95" height="1.79" rx="0.45" ry="0.45"/>
        <path :fill="colorBackground" d="M17,0A17,17,0,1,0,34,17,17,17,0,0,0,17,0ZM28.18,13.87a1.35,1.35,0,0,1-1.34,1.34H26.39v9.17a1.35,1.35,0,0,1-.89,1.26v0.75a1.79,1.79,0,0,1-3.58,0V25.72H12.08v0.67a1.79,1.79,0,0,1-3.58,0V25.64a1.35,1.35,0,0,1-.89-1.26V15.21H7.16a1.35,1.35,0,0,1-1.34-1.34V12.53a1.35,1.35,0,0,1,1.34-1.34H7.61V8.95A2.38,2.38,0,0,1,8.81,7S11.18,5.82,17,5.82,25.19,7,25.19,7a2.38,2.38,0,0,1,1.2,1.94v2.24h0.45a1.35,1.35,0,0,1,1.34,1.34v1.34Z"/>
        <rect :fill="colorBackground" x="9.4" y="11.18" width="15.21" height="8.05" rx="0.45" ry="0.45"/></g>`,
    },
  },
  props: {
    colorBus: {
      type: String,
      default: '#FFF',
    },
    colorBackground: {
      type: String,
      default: '#000',
    },
    colorBearing: {
      type: String,
      default: '#000',
    },
    vehicleType: {
      type: String,
      default: "bus",
    },
    bearing: {
      type: Number,
      required: false,
      default: 0,
    }
  },
  computed: {
    transformBearing() {
      return `rotate(${this.bearing}, 17, 17)`;
    }
  }
}
</script>
